import { Button, Group, Heading, Text } from '@optiaxiom/react';
import styles from './AppsPage.module.css';

interface AppsErrorProps {
  onRetry: () => void;
  /** True while a retry is in flight. */
  retrying?: boolean;
}

/** Shown when the apps list request fails. Offers a retry. */
export function AppsError({ onRetry, retrying = false }: AppsErrorProps) {
  return (
    <Group alignItems="center" flexDirection="column" className={styles.stateContainer}>
      <Heading level="2" fontWeight="700" className={styles.stateTitle}>
        Couldn&rsquo;t load your apps
      </Heading>
      <Text color="fg.secondary" className={styles.stateBody}>
        Something went wrong loading your apps. Please try again.
      </Text>
      <Button appearance="primary" onClick={onRetry} loading={retrying} disabled={retrying}>
        {retrying ? 'Retrying…' : 'Try again'}
      </Button>
    </Group>
  );
}
